import React, {Component} from 'react'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import {Card, Col, List, Row} from 'antd';
import { Button, DatePicker, Select } from 'antd/lib/index'
import moment from 'moment';
import common from '../../common.less'
import CounselingIcon from '../../../assets/icons/counsellar/CounselingIcon.png';
import RegistrationIcon from '../../../assets/icons/counsellar/RegistrationIcon.png';
import Request from '../../../request';
import styles from './styles.less'
import _ from 'lodash'
import InquiryReport from '../../../components/reports/inquiryReports';

import Chart from "react-apexcharts";

const { RangePicker } = DatePicker
const {Option} = Select

const colors = ['#46b3a9', '#26a0fc', '#26e7a6', '#febc3b', '#ff6178', '#8b75d7', '#6d848e', '#a826b7', '#2cadd5', '#cdc755'];

class AllOverallReports extends Component {
  state = {
    showInquiryReport: false,
    branchId: '',
    associatePartnerId: '',
    countryId: '',
    counsellerId: '',
    directCollegeId: '',
    indirectCollegeId: '',
    time: {
      from: moment().clone().startOf('month'),
      to: moment().clone().endOf('month')
    },
    allUsers: [],
    allBranches: [],
    allPartners: [],
    allCountries: [],
    allDirectColleges: [],
    allIndirectColleges: [],

    studentCoachings: [],
    registrations: [],
    applications: [],
    offers: [],
    tuitionFees: [],
    visaRefusals: [],
    visaApprovals: [],
    visaWthdrawals: [],
    visaApplications: [],
    visaWaitings: [],

    series: [],
    options: {
      chart: {
        height: 350,
        type: 'bar',
        events: {
          click: function(chart, w, e) {
            // console.log(chart, w, e)
          }
        }
      },
      colors: colors,
      plotOptions: {
        bar: {
          columnWidth: '45%',
          distributed: true,
        }
      },
      dataLabels: {
        enabled: false
      },
      legend: {
        show: false
      },
      xaxis: {
        categories: [
          'Students', 
          'Coaching', 
          'Registrations', 
          'Applications', 
          'Offers', 
          'Tuition fee payments', 
          'Visa applications', 
          'Visa waiting', 
          'Visa approvals', 
          'Visa refusals',
          'Visa withdrawals'
        ],
        labels: {
          style: {
            colors: colors,
            fontSize: '12px'
          }
        }
      }
    }
  };

  loadFilterData = async() => {
    const response = await Request.getReportFilterData();
    if(response) {
      this.setState({
        allBranches: response.branchs,
        allPartners: response.chennalPartners,
        allCountries: response.countries,
        allDirectColleges: response.directUniversities,
        allIndirectColleges: response.indirectUniversities
      });
    }
  }

  async loadUsers() {
    let {branchId} = this.state
    let {data: userLists} = await Request.loadUser({results: 10000, userBranch: branchId})
    let userList = []
    _.each(userLists, (item) => {
        userList.push({value: item._id, text: item.name})
    })
    this.setState({allUsers: userList})
}

  loadReportStates = async() => {

    const { branchId, counsellerId, associatePartnerId, countryId, directCollegeId, indirectCollegeId, time } = this.state;
    const params = {
      branchId, counsellerId, associatePartnerId, countryId, directCollegeId, indirectCollegeId, time
    };
    const response = await Request.getLoadReportStates(params);
    if(response) {
      this.setState({
        series: [{
          data: [
            response.totalStudents, 
            response.totalCoaching, 
            response.totalRegistrations,
            response.totalApplications, 
            0, 
            0, 
            response.totalVisaApplications, 
            response.totalVisaWaiting, 
            response.totalVisaApproved, 
            response.totalVisaRefused,
            response.totalVisaWithdrawals
          ]
        }],
        studentCoachings: [
          {
            text: 'Students',
            value: response.totalStudents
          },
          {
            text: 'Coaching',
            value: response.totalCoaching
          }
        ],
        registrations: [
          {
            text: 'Total',
            value: response.totalRegistrations
          }
        ],
        applications: [
          {
            text: 'Total',
            value: response.totalApplications
          }
        ],
        offers: [
          {
            text: 'Total',
            value: 0
          }
        ],
        tuitionFees: [
          {
            text: 'Total',
            value: 0
          }
        ],
        visaRefusals: [
          {
            text: 'Total',
            value: response.totalVisaRefused
          }
        ],
        visaApprovals: [
          {
            text: 'Total',
            value: response.totalVisaApproved
          }
        ],
        visaWthdrawals: [
          {
            text: 'Total',
            value: response.totalVisaWithdrawals
          }
        ],
        visaApplications: [
          {
            text: 'Total',
            value: response.totalVisaApplications
          }
        ],
        visaWaitings: [
          {
            text: 'Total',
            value: response.totalVisaWaiting
          }
        ]
      });
    }
  }

  onOk = value => {
    this.loadReportStates()
  }

  chooseRangerPicker = (date, dateString) => {
    this.setState(
      {
        time: {
          from: date[0],
          to: date[1]
        }
      }, () => {
        if (date[0] === undefined) {
          this.loadReportStates()
        }
      }
    )
  }

  openInquiry = async(type, value) => {
    this.setState({type: type, total: value, showInquiryReport: true });
  }
  closeInquiryReport = async() => {
    this.setState({ showInquiryReport: false });
  }

  componentWillMount() {
    this.loadFilterData();
    this.loadReportStates();
  }

  async componentDidMount() {

  }

  render() {
    
    const {allBranches, allUsers, allPartners, allCountries, allDirectColleges, allIndirectColleges} = this.state;

    const { studentCoachings, registrations, applications, offers, tuitionFees, visaRefusals, visaApprovals, visaWthdrawals, visaApplications, visaWaitings } = this.state;

    const { branchId, counsellerId, associatePartnerId, countryId, directCollegeId, indirectCollegeId, time, type, total, showInquiryReport } = this.state;

    const params = {
      branchId, counsellerId, associatePartnerId, countryId, directCollegeId, indirectCollegeId, time, type, total
    };
    
    const startOfMonth = moment().clone().startOf('month').format('YYYY-MM-DD HH:mm:ss');
    const endOfMonth = moment().clone().endOf('month').format('YYYY-MM-DD HH:mm:ss');

    return (
      <PageHeaderWrapper title={` Overall Reports `}>
        { 
          showInquiryReport ? 
            <InquiryReport params={params} onClose={this.closeInquiryReport}/>
          :null
        }
        <div className="site-card-wrapper">
          <Card style={{ marginBottom: 10 }}>
            <div>
              <Row>
                <Col span={8}>
                  <label>Date Range</label>
                  <RangePicker
                    showTime={{ format: 'HH:mm' }}
                    format="YYYY-MM-DD HH:mm"
                    placeholder={[startOfMonth, endOfMonth]}
                    onChange={this.chooseRangerPicker}
                    onOk={this.onOk}
                  />
                </Col>
                <Col span={1}></Col>
                <Col span={4}>
                  <label>Branch Wise</label>
                  <Select
                    showSearch
                    allowClear
                    optionFilterProp="children"
                    style={{
                      width: 225,
                      marginRight: 16
                    }}
                    value={this.state.branchId}
                    placeholder="Select Option"
                    onChange={branchId => {
                      this.setState(
                        {
                          branchId: branchId && branchId.toString(),
                          userId: ''
                        },
                        () => {
                          this.loadUsers()
                        }
                      )
                    }}>
                    {allBranches.map((val, idn) => {
                      return (
                        <Option key={idn} value={val.branchId}>
                          {val.branchName}
                        </Option>
                      )
                    })}
                  </Select>                    
                </Col>                
                <Col span={1}></Col>
                <Col span={4}>
                  <label>Counsellor Wise</label>
                  <Select
                    showSearch
                    allowClear
                    optionFilterProp="children"
                    value={this.state.counsellerId}
                    placeholder="Select Option"
                    style={{
                      width: 225,
                      marginRight: 16
                    }}
                    onChange={userId => {
                      this.setState(
                        {
                          counsellerId: userId && userId.toString()
                        },
                        () => {
                          this.loadReportStates()
                        }
                      )
                    }}>
                    {allUsers.map((val, idn) => {
                      return (
                        <Option key={idn} value={val.value}>
                          {val.text}
                        </Option>
                      )
                    })}
                  </Select>
                </Col>
                <Col span={1}></Col>
                <Col span={4}>
                  <label>Associate Partner Wise</label>
                  <Select
                    allowClear
                    style={{
                      width: 225,
                      marginRight: 16
                    }}
                    showSearch={true}
                    className={common.width100Pr}
                    value={this.state.associatePartnerId}
                    placeholder="Select Option"
                    optionFilterProp="display"
                    onChange={associatePartnerId => {
                      this.setState(
                        {
                          associatePartnerId: associatePartnerId && associatePartnerId.toString()
                        },
                        () => {
                          this.loadReportStates()
                        }
                      )
                    }}
                    filterOption={(input, option) => {
                      return (
                        option.props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      )
                    }}>
                      {allPartners.map((val, idn) => {
                        return (
                          <Option key={idn} value={val._id}>
                            {val.channelPartnerName}
                          </Option>
                        )
                      })}
                  </Select>
                </Col>
                <Col span={1}></Col>
                <Col span={4}>
                  <label>Country Wise</label>
                  <Select
                    allowClear
                    style={{
                      width: 225,
                      marginRight: 16
                    }}
                    showSearch={true}
                    className={common.width100Pr}
                    value={this.state.countryId}
                    placeholder="Select Option"
                    optionFilterProp="display"
                    onChange={countryId => {
                      this.setState(
                        {
                          countryId: countryId && countryId.toString()
                        },
                        () => {
                          this.loadReportStates()
                        }
                      )
                    }}
                    filterOption={(input, option) => {
                      return (
                        option.props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      )
                    }}>
                      {allCountries.map((val, idn) => {
                        return (
                          <Option key={idn} value={val.countryId}>
                            {val.countryName}
                          </Option>
                        )
                      })} 
                  </Select>
                </Col>
                <Col span={1}></Col>
                <Col span={4}>
                  <label>Direct Colleges</label>
                  <Select
                    allowClear
                    style={{
                      width: 225,
                      marginRight: 16
                    }}
                    showSearch={true}
                    className={common.width100Pr}
                    value={this.state.directCollegeId}
                    placeholder="Select Option"
                    optionFilterProp="display"
                    onChange={directCollegeId => {
                      this.setState(
                        {
                          directCollegeId: directCollegeId && directCollegeId.toString()
                        },
                        () => {
                          this.loadReportStates()
                        }
                      )
                    }}
                    filterOption={(input, option) => {
                      return (
                        option.props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      )
                    }}>
                      {allDirectColleges.map((val, idn) => {
                        return (
                          <Option key={idn} value={val.id}>
                            {val.universityInstitutionName}
                          </Option>
                        )
                      })}
                  </Select>
                </Col>
                <Col span={1}></Col>
                <Col span={4}>
                  <label>Indirect Colleges</label>
                  <Select
                    allowClear
                    style={{
                      width: 225,
                      marginRight: 16
                    }}
                    showSearch={true}
                    className={common.width100Pr}
                    value={this.state.indirectCollegeId}
                    placeholder="Select Option"
                    optionFilterProp="display"
                    onChange={indirectCollegeId => {
                      this.setState(
                        {
                          indirectCollegeId: indirectCollegeId && indirectCollegeId.toString()
                        },
                        () => {
                          this.loadReportStates()
                        }
                      )
                    }}
                    filterOption={(input, option) => {
                      return (
                        option.props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      )
                    }}>
                      {allIndirectColleges.map((val, idn) => {
                        return (
                          <Option key={idn} value={val.id}>
                            {val.universityInstitutionName}
                          </Option>
                        )
                      })}
                  </Select>
                </Col>
                <Col span={1}></Col>
                <Col span={4}>
                  <label>&nbsp;<br></br>&nbsp;</label>
                  <div className='antd-pro-containers-finance-all-styles-myBtnGroup'>
                    <Button
                      type={'primary'}
                      className={styles.btn}
                      onClick={() => this.loadReportStates()}> Search
                    </Button>
                  </div>
                </Col>
              </Row>
            </div>
          </Card>
          <Row gutter={16}>
            <Col span={6}>
              <Card
                headStyle={{
                  backgroundColor: '#26a0fc',
                  color: 'white',
                  minHeight: '11px',
                  fontSize: '15px'
                }}
                style={{height: '184px', marginTop: "20px"}}
                bodyStyle={{padding: '4px'}}
                title={
                  <span><img src={CounselingIcon} alt="Smiley face" height="22" width="22"/>
                  <span style={{paddingLeft: '10px'}}>Inquiries students and coaching</span></span>
                }>
                <List
                  size="small"
                  bordered={false}
                  dataSource={studentCoachings}
                  renderItem={val => (
                    <List.Item>
                      <div style={{display: 'flex', justifyContent: 'space-around', width: '100%'}}>
                        <div style={{color: '#26a0fc'}}>{val.text}</div>
                        <div>-</div>
                        <div><button onClick={(e) => {this.openInquiry(val.text, val.value)}}>{val.value}</button></div>
                      </div>
                    </List.Item>)
                  }
                >
                </List>
              </Card>
            </Col>
            <Col span={6}>
              <Card
                headStyle={{
                  backgroundColor: '#26e7a6',
                  color: 'white',
                  minHeight: '11px',
                  fontSize: '15px'
                }}
                style={{height: '184px', marginTop: "20px"}}
                bodyStyle={{padding: '4px'}}
                title={
                  <span>
                    <img src={RegistrationIcon} alt="Smiley face" height="22" width="22"/>
                    <span style={{paddingLeft: '5px'}}>Registrations</span>
                  </span>
                }>
                <List
                  size="small"
                  bordered={false}
                  dataSource={registrations}
                  renderItem={val => (
                    <List.Item>
                      <div style={{display: 'flex', justifyContent: 'space-around', width: '100%'}}>
                        <div style={{color: '#26e7a6'}}>{val.text}</div>
                        <div>-</div>
                        <div><button onClick={(e) => {this.openInquiry('registrations', val.value)}}>{val.value}</button></div>
                      </div>
                    </List.Item>
                  )}
                  >
                </List>
              </Card>
            </Col>
            <Col span={6}>
              <Card
                headStyle={{
                  backgroundColor: '#febc3b',
                  color: 'white',
                  minHeight: '11px',
                  fontSize: '15px'
                }}
                style={{height: '184px', marginTop: "20px"}}
                bodyStyle={{padding: '4px'}}
                title={
                  <span>
                    <img src={RegistrationIcon} alt="Smiley face" height="22" width="22"/>
                    <span style={{paddingLeft: '5px'}}>Applications</span>
                  </span>
                }>
                <List
                  size="small"
                  bordered={false}
                  dataSource={applications}
                  renderItem={val => (
                    <List.Item>
                      <div style={{display: 'flex', justifyContent: 'space-around', width: '100%'}}>
                        <div style={{color: '#febc3b'}}>{val.text}</div>
                        <div>-</div>
                        <div><button onClick={(e) => {this.openInquiry('applications', val.value)}}>{val.value}</button></div>
                      </div>
                    </List.Item>
                  )}
                  >
                </List>
              </Card>
            </Col>
            <Col span={6}>
              <Card
                headStyle={{
                  backgroundColor: '#ff6178',
                  color: 'white',
                  minHeight: '11px',
                  fontSize: '15px'
                }}
                style={{height: '184px', marginTop: "20px"}}
                bodyStyle={{padding: '4px'}}
                title={
                  <span>
                    <img src={RegistrationIcon} alt="Smiley face" height="22" width="22"/>
                    <span style={{paddingLeft: '5px'}}>Offers</span>
                  </span>
                }>
                <List
                  size="small"
                  bordered={false}
                  dataSource={offers}
                  renderItem={val => (
                    <List.Item>
                      <div style={{display: 'flex', justifyContent: 'space-around', width: '100%'}}>
                        <div style={{color: '#ff6178'}}>{val.text}</div>
                        <div>-</div>
                        <div><button onClick={(e) => {this.openInquiry('offers', val.value)}}>{val.value}</button></div>
                      </div>
                    </List.Item>
                  )}
                  >
                </List>
              </Card>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={6}>
              <Card
                headStyle={{
                  backgroundColor: '#8b75d7',
                  color: 'white',
                  minHeight: '11px',
                  fontSize: '15px'
                }}
                style={{height: '184px', marginTop: "20px"}}
                bodyStyle={{padding: '4px'}}
                title={
                  <span>
                    <img src={RegistrationIcon} alt="Smiley face" height="22" width="22"/>
                    <span style={{paddingLeft: '5px'}}>Tuition fee payments</span>
                  </span>
                }>
                <List
                  size="small"
                  bordered={false}
                  dataSource={tuitionFees}
                  renderItem={val => (
                    <List.Item>
                      <div style={{display: 'flex', justifyContent: 'space-around', width: '100%'}}>
                        <div style={{color: '#8b75d7'}}>{val.text}</div>
                        <div>-</div>
                        <div><button onClick={(e) => {this.openInquiry('tuition_fee', val.value)}}>{val.value}</button></div>
                      </div>
                    </List.Item>
                  )}
                  >
                </List>
              </Card>
            </Col>
            <Col span={6}>
              <Card
                headStyle={{
                  backgroundColor: '#6d848e',
                  color: 'white',
                  minHeight: '11px',
                  fontSize: '15px'
                }}
                style={{height: '184px', marginTop: "20px"}}
                bodyStyle={{padding: '4px'}}
                title={
                  <span>
                    <img src={RegistrationIcon} alt="Smiley face" height="22" width="22"/>
                    <span style={{paddingLeft: '5px'}}>Visa applications</span>
                  </span>
                }>
                <List
                  size="small"
                  bordered={false}
                  dataSource={visaApplications}
                  renderItem={val => (
                    <List.Item>
                      <div style={{display: 'flex', justifyContent: 'space-around', width: '100%'}}>
                        <div style={{color: '#6d848e'}}>{val.text}</div>
                        <div>-</div>
                        <div><button onClick={(e) => {this.openInquiry('visaApplication', val.value)}}>{val.value}</button></div>
                      </div>
                    </List.Item>
                  )}
                  >
                </List>
              </Card>
            </Col>
            <Col span={6}>
              <Card
                headStyle={{
                  backgroundColor: '#a826b7',
                  color: 'white',
                  minHeight: '11px',
                  fontSize: '15px'
                }}
                style={{height: '184px', marginTop: "20px"}}
                bodyStyle={{padding: '4px'}}
                title={
                  <span>
                    <img src={RegistrationIcon} alt="Smiley face" height="22" width="22"/>
                    <span style={{paddingLeft: '5px'}}>Visa waiting</span>
                  </span>
                }>
                <List
                  size="small"
                  bordered={false}
                  dataSource={visaWaitings}
                  renderItem={val => (
                    <List.Item>
                      <div style={{display: 'flex', justifyContent: 'space-around', width: '100%'}}>
                        <div style={{color: '#a826b7'}}>{val.text}</div>
                        <div>-</div>
                        <div><button onClick={(e) => {this.openInquiry('visaWaiting', val.value)}}>{val.value}</button></div>
                      </div>
                    </List.Item>
                  )}
                  >
                </List>
              </Card>
            </Col>
            <Col span={6}>
              <Card
                headStyle={{
                  backgroundColor: '#2cadd5',
                  color: 'white',
                  minHeight: '11px',
                  fontSize: '15px'
                }}
                style={{height: '184px', marginTop: "20px"}}
                bodyStyle={{padding: '4px'}}
                title={
                  <span>
                    <img src={RegistrationIcon} alt="Smiley face" height="22" width="22"/>
                    <span style={{paddingLeft: '5px'}}>Visa approvals</span>
                  </span>
                }>
                <List
                  size="small"
                  bordered={false}
                  dataSource={visaApprovals}
                  renderItem={val => (
                    <List.Item>
                      <div style={{display: 'flex', justifyContent: 'space-around', width: '100%'}}>
                        <div style={{color: '#2cadd5'}}>{val.text}</div>
                        <div>-</div>
                        <div><button onClick={(e) => {this.openInquiry('visaApprovals', val.value)}}>{val.value}</button></div>
                      </div>
                    </List.Item>
                  )}
                  >
                </List>
              </Card>
            </Col>
          </Row>
          <Row gutter={16}></Row>
          <Row gutter={16}>
            <Col span={6}>
              <Card
                headStyle={{
                  backgroundColor: '#cdc755',
                  color: 'white',
                  minHeight: '11px',
                  fontSize: '15px'
                }}
                style={{height: '184px', marginTop: "20px"}}
                bodyStyle={{padding: '4px'}}
                title={
                  <span>
                    <img src={RegistrationIcon} alt="Smiley face" height="22" width="22"/>
                    <span style={{paddingLeft: '5px'}}>Visa refusals</span>
                  </span>
                }>
                <List
                  size="small"
                  bordered={false}
                  dataSource={visaRefusals}
                  renderItem={val => (
                    <List.Item>
                      <div style={{display: 'flex', justifyContent: 'space-around', width: '100%'}}>
                        <div style={{color: '#cdc755'}}>{val.text}</div>
                        <div>-</div>
                        <div><button onClick={(e) => {this.openInquiry('visaRefusals', val.value)}}>{val.value}</button></div>
                      </div>
                    </List.Item>
                  )}
                  >
                </List>
              </Card>
            </Col>
            <Col span={6}>
              <Card
                headStyle={{
                  backgroundColor: '#46b3a9',
                  color: 'white',
                  minHeight: '11px',
                  fontSize: '15px'
                }}
                style={{height: '184px', marginTop: "20px"}}
                bodyStyle={{padding: '4px'}}
                title={
                  <span>
                    <img src={RegistrationIcon} alt="Smiley face" height="22" width="22"/>
                    <span style={{paddingLeft: '5px'}}>Visa withdrawals</span>
                  </span>
                }>
                <List
                  size="small"
                  bordered={false}
                  dataSource={visaWthdrawals}
                  renderItem={val => (
                    <List.Item>
                      <div style={{display: 'flex', justifyContent: 'space-around', width: '100%'}}>
                        <div style={{color: '#46b3a9'}}>{val.text}</div>
                        <div>-</div>
                        <div><button  onClick={(e) => {this.openInquiry('visaWithdrawals', val.value)}}>{val.value}</button></div>
                      </div>
                    </List.Item>
                  )}
                  >
                </List>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col>
              <Card
                headStyle={{
                  backgroundColor: '#2B208D',
                  color: 'white',
                  minHeight: '11px',
                  fontSize: '15px'
                }}
                style={{minHeight: '384px', marginTop: "20px"}}
                bodyStyle={{padding: '4px'}}
                title={
                  <span>
                    <img src={RegistrationIcon} alt="Smiley face" height="22" width="22"/>
                    <span style={{paddingLeft: '5px'}}>Overall Report Chart</span>
                  </span>
                }>
                  <Chart options={this.state.options} series={this.state.series} type="bar" width={1100} height={350} />
                </Card>
            </Col>
          </Row>
        </div>
      </PageHeaderWrapper>
    );
  }
}

export default AllOverallReports
